import trackEventGa4 from './trackEventGa4'

export default (trackingData: object|null, hasBidBefore: boolean, googleAdsConversionTarget: string = null) => {
    if(!trackingData) {
        return
    }

    // for now, we do not track this as a standard ecommerce purchase
    //trackEventGa4('purchase', trackingData)

    // google-ads conversion tracking

    if(googleAdsConversionTarget) {
        trackEventGa4('conversion', {
            send_to: googleAdsConversionTarget,
            value: trackingData.value,
            currency: trackingData.currency,
            transaction_id: trackingData.transaction_id
        })
    }
    
    // google-analytics 4
    
    trackEventGa4('purchase_agent', {
        value: trackingData.value,
        bid_value: trackingData.value,
        currency: trackingData.currency,
        sku: trackingData.items[0].item_id
    })
    
    if(!hasBidBefore) {
        trackEventGa4('first_purchase_agent', {
            value: trackingData.value,
            bid_value: trackingData.value,
            currency: trackingData.currency,
            sku: trackingData.items[0].item_id
        })
    }
    
    // algolia

    window.algolia.purchase([trackingData.items[0].item_id])
}